import {  Section } from "../interfaces/course";

export interface FilterObj {
    title: string;
    value: number;
    category: string;
}

export const transformedArrayForFilters = (object: Record<string, number>): FilterObj[] => {
    return Object.entries(object).map(([key, value]) => {
        let title = key.split('-')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
        const category = key; 

        if(title === "True"){
            title = "Purchased"
        }
        if(title === "False"){
            title = "Not Purchased"
        }
        return {
            title: title,
            value: value,
            category: category
        };
    });
};




// export function processData(sections: Section[]): { courseType: Record<string, number>, purchased: Record<string, number>, instructors: Record<string, number> } {
//     const courseType: Record<string, number> = {};
//     const purchased: Record<string, number> = {};
//     const instructors: Record<string, number> = {};

//     sections?.forEach(section => {
//         section.things.forEach(thing => {
//             thing.filters.forEach(filter => {
//                 if (filter.startsWith('category:')) {
//                     const category = filter.split(':')[1];
//                     courseType[category] = courseType[category] ? courseType[category] + 1 : 1;
//                 } else if (filter.startsWith('purchased:')) {
//                     const status = filter.split(':')[1];
//                     purchased[status] = purchased[status] ? purchased[status] + 1 : 1;
//                 } else if (filter.startsWith('instructor:')) {
//                     const instructor = filter.split(':')[1];
//                     instructors[instructor] = instructors[instructor] ? instructors[instructor] + 1 : 1;
//                 }
//             });
//         });
//     });

//     return { courseType, purchased, instructors };
// }

export function processData(sections: Section[]): { 
    courseType: Record<string, number>, 
    purchased: Record<string, number>, 
    instructors: Record<string, number>,
    productType: Record<string, number>
} {
    const courseType: Record<string, number> = {};
    const purchased: Record<string, number> = {};
    const instructors: Record<string, number> = {};
    const productType: Record<string, number> = {};

    const uniqueCourseIds = new Set<number>();

    sections?.forEach(section => {
        section.things.forEach(thing => {
            // if thing.ID does not exist alreaady
            if (!uniqueCourseIds.has(thing.ID)) {
                uniqueCourseIds.add(thing.ID);

                thing.filters.forEach(filter => {
                    if (filter.startsWith('category:')) {
                        const category = filter.split(':')[1];
                        courseType[category] = courseType[category] ? courseType[category] + 1 : 1;
                    } else if (filter.startsWith('purchased:')) {
                        const status = filter.split(':')[1];
                        purchased[status] = purchased[status] ? purchased[status] + 1 : 1;
                    } else if (filter.startsWith('instructor:')) {
                        const instructor = filter.split(':')[1];
                        instructors[instructor] = instructors[instructor] ? instructors[instructor] + 1 : 1;
                    } else if (filter.startsWith('product_type:')) {
                        const type = filter.split(':')[1];
                        productType[type] = productType[type] ? productType[type] + 1 : 1;
                    }
                });
            }
        });
    });

    return { courseType, purchased, instructors, productType };
}



export function getFilterPrefix(filterType: string): string {
    switch (filterType) {
        case "Course Type":
            return "category:";
        case "Instructor":
            return "instructor:";
        case "Purchased":
            return "purchased:";
        case "Product Type":
            return "product_type:";
        default:
            return "";
    }
}


export const isSelectedFilterNotEmpty = (selectedFilters:Record<string, string[]>) => {
    return Object.values(selectedFilters).some(filters => filters.length > 0);
};